/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  /*
    Observe whether or not there are open modals that require scroll lock
  */

  function hasOpenModals() {
    const openModals = Boolean(document.querySelectorAll('dialog[open][data-scroll-lock-required]').length);
    const openDrawers = Boolean(document.querySelectorAll('.drawer.is-open').length);

    return openModals || openDrawers;
  }

  function focusable(container) {
    var elements = Array.prototype.slice.call(
      container.querySelectorAll('[tabindex],' + '[draggable],' + 'a[href],' + 'area,' + 'button:enabled,' + 'input:not([type=hidden]):enabled,' + 'object,' + 'select:enabled,' + 'textarea:enabled')
    );

    // Filter out elements that are not visible.
    // Copied from jQuery https://github.com/jquery/jquery/blob/2d4f53416e5f74fa98e0c1d66b6f3c285a12f0ce/src/css/hiddenVisibleSelectors.js
    return elements.filter(function (element) {
      return !!((element.offsetWidth || element.offsetHeight || element.getClientRects().length) && isVisible(element));
    });
  }

  function isVisible(el) {
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  /**
   * Moves focus to an HTML element
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects. Used in bindInPageLinks()
   * eg move focus to a modal that is opened. Used in trapFocus()
   *
   * @param {Element} container - Container DOM element to trap focus inside of
   * @param {Object} options - Settings unique to your theme
   * @param {string} options.className - Class name to apply to element on focus.
   */
  function forceFocus(element, options) {
    options = options || {};

    var savedTabIndex = element.tabIndex;

    element.tabIndex = -1;
    element.dataset.tabIndex = savedTabIndex;
    element.focus();
    if (typeof options.className !== 'undefined') {
      element.classList.add(options.className);
    }
    element.addEventListener('blur', callback);

    function callback(event) {
      event.target.removeEventListener(event.type, callback);

      element.tabIndex = savedTabIndex;
      delete element.dataset.tabIndex;
      if (typeof options.className !== 'undefined') {
        element.classList.remove(options.className);
      }
    }
  }

  /**
   * Traps the focus in a particular container
   *
   * @param {Element} container - Container DOM element to trap focus inside of
   * @param {Element} elementToFocus - Element to be focused on first
   * @param {Object} options - Settings unique to your theme
   * @param {string} options.className - Class name to apply to element on focus.
   */

  var trapFocusHandlers = {};

  function trapFocus(container, options) {
    options = options || {};
    var elements = focusable(container);
    var elementToFocus = options.elementToFocus || container;
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = function (event) {
      if (container !== event.target && !container.contains(event.target) && first && first === event.target) {
        first.focus();
      }

      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
      if (event.code !== 'Tab') return; // If not TAB key

      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }

      //  On the first focusable element and tab backward, focus the last element.
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    forceFocus(elementToFocus, options);
  }

  /**
   * Removes the trap of focus from the page
   */
  function removeTrapFocus() {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  }

  /**
   * Auto focus the last element
   */
  function autoFocusLastElement() {
    if (window.a11y.lastElement && document.body.classList.contains('is-focused')) {
      setTimeout(() => {
        window.a11y.lastElement?.focus();
      });
    }
  }

  var a11y = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    forceFocus: forceFocus,
    trapFocus: trapFocus,
    removeTrapFocus: removeTrapFocus,
    autoFocusLastElement: autoFocusLastElement
  });

  /*
    Trigger event after animation completes
  */
  function waitForAnimationEnd(element) {
    return new Promise((resolve) => {
      function onAnimationEnd(event) {
        if (event.target != element) return;

        element.removeEventListener('animationend', onAnimationEnd);
        resolve();
      }

      element?.addEventListener('animationend', onAnimationEnd);
    });
  }
  const selectors$a = {
    open: '[data-popup-open]',
    close: '[data-popup-close]',
    focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
  };
  const attributes$7 = {
    closing: 'closing',
  };
  class PopupActions {
    constructor(popup, holder, showModal = true, scrollLock = true) {
      this.popup = popup;
      this.holder = holder;
      this.a11y = a11y;
      this.isAnimating = false;
      this.showModal = showModal;
      this.enableScrollLock = scrollLock;
      this.buttonPopupOpen = this.holder?.querySelector(selectors$a.open);

      this.popupEvents();
    }

    popupOpen() {
      if (!this.popup) return;

      this.isAnimating = true;

      // Check if browser supports Dialog tags
      if (this.showModal && typeof this.popup.showModal === 'function') {
        this.popup.showModal();
      } else if (!this.showModal && typeof this.popup.show === 'function') {
        this.popup.show();
      } else {
        this.popup.setAttribute('open', '');
      }

      this.popup.removeAttribute('inert');
      this.popup.setAttribute('aria-hidden', false);
      this.popup.focus(); // Focus <dialog> tag element to prevent immediate closing on Escape keypress

      if (this.enableScrollLock) {
        document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
      }

      waitForAnimationEnd(this.popup).then(() => {
        this.isAnimating = false;

        if (this.enableScrollLock) {
          this.a11y.trapFocus(this.popup);
        }

        const focusTarget = this.popup.querySelector('[autofocus]') || this.popup.querySelector(selectors$a.focusable);
        focusTarget?.focus();
      });
    }

    popupClose() {
      if (this.isAnimating || !this.popup || this.popup.hasAttribute('inert')) {
        return;
      }

      if (!this.popup.hasAttribute(attributes$7.closing)) {
        this.popup.setAttribute(attributes$7.closing, '');
        this.isAnimating = true;

        waitForAnimationEnd(this.popup).then(() => {
          this.isAnimating = false;
          this.popupClose();
        });

        return;
      }

      // Check if browser supports Dialog tags
      if (typeof this.popup.close === 'function') {
        this.popup.close();
      } else {
        this.popup.removeAttribute('open');
        this.popup.setAttribute('aria-hidden', true);
      }

      this.popupCloseActions();
    }

    popupCloseActions() {
      if (this.popup.hasAttribute('inert')) return;

      this.popup.setAttribute('inert', '');
      this.popup.setAttribute('aria-hidden', true);
      this.popup.removeAttribute(attributes$7.closing);

      // Unlock scroll if no other popups & modals are open
      if (!hasOpenModals() && this.enableScrollLock) {
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
      }

      this.popup.dispatchEvent(new CustomEvent('theme:popup:onclose', {bubbles: false}));

      if (this.enableScrollLock) {
        this.a11y.removeTrapFocus();
        this.a11y.autoFocusLastElement();
      }
    }

    popupEvents() {
      if (!this.popup) return;

      // Open button click event
      this.buttonPopupOpen?.addEventListener('click', (e) => {
        e.preventDefault();
        this.popupOpen();
        window.a11y.lastElement = this.buttonPopupOpen;
      });

      // Close button click event
      const closeButtons = this.popup.querySelectorAll(selectors$a.close);
      if (closeButtons.length) {
        closeButtons.forEach((closeButton) => {
          closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.popupClose();
          });
        });
      }

      // Close dialog on click outside content
      if (this.showModal) {
        this.popup.addEventListener('click', (event) => {
          if (event.target.nodeName === 'DIALOG' && event.type === 'click') {
            this.popupClose();
          }
        });
      }

      // Close dialog on click ESC key pressed
      this.popup.addEventListener('keydown', (event) => {
        if (event.code === 'Escape') {
          event.preventDefault();
          this.popupClose();
        }
      });

      this.popup.addEventListener('close', () => this.popupCloseActions());
    }
  }

  class ModalContent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      new PopupActions(this.querySelector('dialog'), this, true, true);
    }
  }

  class RsQuickAddProduct extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.RS_WAITLIST_MODAL_OPEN_EVENT = 'rsWaitlistModal:open';
      this.sizeSelectors = [...this.querySelectorAll('.size')];
      this.variantsJson = this.querySelector('.variants-json');
      this.variants = [];
      this.product = {};
      if (this.variantsJson && this.variantsJson.innerText) {
        this.variants = JSON.parse(this.variantsJson.innerText)?.variants;
        this.product = JSON.parse(this.variantsJson.innerText)?.product;
      }
      this.sizeSelectors.forEach((sizeSelector) => {
        sizeSelector.addEventListener('click', this.handleSizeSelectorClick.bind(this));
      });
      this.checkAvailability();
    }

    checkAvailability() {
      this.variants.forEach((variant, idx) => {
        if(!variant.available) {
          this.sizeSelectors[idx].classList.add('soldout');
        }
      });
    }

    async handleSizeSelectorClick(event) {
      event.preventDefault();
      event.stopPropagation();
      
      const sizeSelector = event.currentTarget;
      let variant = this.getVariantBySize(sizeSelector.dataset.value);

      if (event.currentTarget.classList.contains('soldout')) {
        document.dispatchEvent(
          new CustomEvent(this.RS_WAITLIST_MODAL_OPEN_EVENT, {
            bubbles: true,
            detail: {
              "productTitle": this.product?.title,
              "productId": this.product?.id,
              "variantId": variant?.id,
              "variantTitle": variant?.title
            }
          })
        );
      } else {
        await this.addToCart(variant?.id, event?.target);
      }
    }

    getVariantBySize(size) {
      let variant = this.variants.find((variant) => {
        if (variant.option_1 === size || variant.option_2 === size || variant.option_3 === size) {
          return variant;
        }
      });
      return variant;
    }

    async addToCart(variantId) {
      try {
        const response = await fetch(theme.routes.cart_add_url, {
          method: "POST",
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            "Content-Type": "application/json",
            "Accept": "application/javascript"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        const data = await response.json();

        if (response.ok) {
          document.dispatchEvent(
            new CustomEvent('theme:cart:refresh', {
              bubbles: true,
            })
          );

        } else {
          this.handleCartError(data);
        }
      } catch (error) {
        console.log("****** |Error Adding to cart:", error)
        this.handleCartError({ message: "Error Adding to Cart", description: "Please try again" });
      }
    }
    handleCartError(data) {
      const errorContainer = document.querySelector(`[data-cart-errors-container="${this.id}"]`);
      if (errorContainer) {
        let errorMessage = `${data.message}: ${data.description}`;

        if (data.message == data.description) {
          errorMessage = data.message;
        }

        errorContainer.innerHTML = `<div class="errors form-errors">${errorMessage}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`;
        errorContainer.classList.add('is-visible');
        this.formErrorsEvents(errorContainer);
      }
    }
    formErrorsEvents(errorContainer) {
      const buttonErrorClose = errorContainer.querySelector('[data-close-error]');
      buttonErrorClose?.addEventListener('click', (e) => {
        e.preventDefault();

        if (errorContainer) {
          errorContainer.classList.remove('is-visible');
        }
      });
    } 
  }

  class RsWaitListModal extends HTMLElement {
    constructor() {
      super();
      this.BIS_SUBMISSION_EVENT = 'klaviyo:bisSubmission';
      this.RS_WAITLIST_MODAL_OPEN_EVENT = 'rsWaitlistModal:open';
      this.HIDDEN_CLASS = 'hidden';

      this.waitlistModalOverlay = document.querySelector('.waitlist-modal-overlay');
      this.closeButton = this.querySelector('.waitlist-modal-close');
      this.closeLink = this.querySelector('.waitlist-modal-close-text');
      this.productTitleElement = this.querySelector('.waitlist-modal-title');
      this.productIdElement = this.querySelector("rs-wait-list-modal input[type='hidden'][name='product']");
      this.variantTitleElement = this.querySelector(".waitlist-modal-variant-title");
      this.variantIdElement = this.querySelector("rs-wait-list-modal input[type='hidden'][name='variant']");
      this.form = this.querySelector('form');
      this.apiVersion = this.dataset.apiVersion || '2024-07-15';
      this.companyId = this.dataset.companyId;
      this.successMessage = this.querySelector(".success-message");
      this.errorMessage = this.querySelector(".error-message");

      document.addEventListener(this.RS_WAITLIST_MODAL_OPEN_EVENT, this.openModal.bind(this));

      this?.waitlistModalOverlay?.addEventListener('click', this.closeModal.bind(this));
      this?.closeButton?.addEventListener('click', this.closeModal.bind(this));
      this?.closeLink?.addEventListener('click', this.closeModal.bind(this));
      this?.form?.addEventListener('submit', this.handleSubmit.bind(this));
      document.addEventListener(this.BIS_SUBMISSION_EVENT, this.handleBisSubmissionResp.bind(this));
    }
    connectedCallback() {
    }
    openModal(event) {
      this.updateContent(event.detail);

      this.waitlistModalOverlay.classList.add('is-open');
      this.classList.add('is-open');
    }
    closeModal() {
      this.waitlistModalOverlay.classList.remove('is-open');
      this.classList.remove('is-open');
      this.successMessage?.classList?.add(this.HIDDEN_CLASS);
      this.errorMessage?.classList?.add(this.HIDDEN_CLASS); 
    }
    updateContent(detail) {
      this.productTitle = detail?.productTitle;
      this.productId = detail?.productId;
      this.variantTitle = detail?.variantTitle;
      this.variantId = detail?.variantId;

      if (this.productTitleElement) {
        this.productTitleElement.innerText = this.productTitle;
      }
      if (this.productIdElement) {
        this.productIdElement.value = this.productId;
      }
      if (this.variantTitleElement) {
        this.variantTitleElement.innerText = this.variantTitle;
      }
      if (this.variantIdElement) {
        this.variantIdElement.value = this.variantId;
      }
    }
    async handleSubmit(e) {
      e.preventDefault();
      const formData = new FormData(this.form);
      const variantId = formData.get('variant');
      const email = formData.get('email');

      if (!variantId || !this.companyId || !this.apiVersion) {
        console.log("Missing params");
      } else if (!email) {
        console.log("Email required");
      } else {
        const data = {
          email,
          variantId,
          companyId: this.companyId,
          apiVersion: this.apiVersion
        };

        // Submit the back in stock
        const resp = await this.submitBIS(data);
      }
    }
    async submitBIS(data) {
      const resp = {};
      if (!data) {
        resp.ok = false;
        resp.errorData = {
          message: 'Missing data'
        }
      } else {
        const body = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: data.email
                  }
                }
              },
              "channels": ["EMAIL"],
            },
            relationships: { 
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${data.variantId}`
                }
              }
            }
          }
        };

        const headers = {
          revision: data.apiVersion,
          'content-type': 'application/json'
        }
        const options = {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(body)
        };
        const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${data.companyId}`;

        const payload = {
          detail: {
            target: this
          }
        };

        try {
          const response = await fetch(url,options);
          payload.detail.response = response;

          if (response?.ok) {
            payload.detail.success = true;
          } else {
            payload.detail.success = false;
          }
        } catch (error) {
          console.log("****** | RsKlaviyoBis | submitBIS | error:", error);
          payload.detail.success = false;
        }

        if (payload.detail.success) {
          resp.ok = true;
        } else {
          resp.ok = false;
          resp.errorData = {
            message: 'Error submitting Klaviyo back in stock.'
          }
        }

        const event = new CustomEvent(this.BIS_SUBMISSION_EVENT, payload);
        document.dispatchEvent(event);
      }

      return resp;
    }

    handleBisSubmissionResp(e) {
      const target = e?.detail?.target;
      const response = e?.detail?.response;

      if (target && response) {
        this.successMessage?.classList?.add(this.HIDDEN_CLASS);
        this.errorMessage?.classList?.add(this.HIDDEN_CLASS); 

        if (response?.ok) {
          this.successMessage?.classList?.remove(this.HIDDEN_CLASS);
        } else {
          if(this.errorMessage) {
            this.errorMessage.innerText = 'Error submitting Klaviyo back in stock.';
            this.errorMessage.classList.remove(this.HIDDEN_CLASS);
          }
        }
      }
    }
  }

  if (!customElements.get('modal-content')) {
    customElements.define('modal-content', ModalContent);
  }

  if (!customElements.get('rs-quick-add-product')) {
    customElements.define('rs-quick-add-product', RsQuickAddProduct);
  }

  if (!customElements.get('rs-wait-list-modal')) {
    customElements.define('rs-wait-list-modal', RsWaitListModal);
  }

  // Header points dropdown
  const yotpoPoints = document.getElementById('yotpo-points');
  const pointsDrownContainer = document.getElementById('points-dropdown-container');
  yotpoPoints?.addEventListener('click', (e) => {
    pointsDrownContainer.classList.remove('hidden');
  });
  document.addEventListener('click', (e) => {
    if(!e?.target?.closest('#yotpo-points') && !e?.target?.closest('#points-dropdown-container')) {
      pointsDrownContainer?.classList.add('hidden');
    }
  });

  const removeShippingProtection = async () => {
    try {
      console.log("LABL Custom")
      const response = await fetch("/cart.js");

      if(response.ok){
        const cart = await response.json();

        const lablItems = cart?.items?.filter((i)=>i.vendor?.toLowerCase().includes("lablpx"));

        if (lablItems?.length) {
          await Promise.all(
            lablItems.map((item) =>
              fetch("/cart/change.js", {
                method: "POST",
                 headers: {
                  "X-Requested-With": "XMLHttpRequest",
                  "Content-Type": "application/json",
                  "Accept": "application/javascript"
                },
                body: JSON.stringify({
                  quantity: 0,
                  id: item.id.toString(),
                }),
              })
            )
          );

          document.dispatchEvent(
            new CustomEvent('theme:cart:refresh', {
              bubbles: false,
            })
          );
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
  setTimeout(()=>{
    removeShippingProtection();
  },1000)

  class TruncateText extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: "open" });
      this.shadowRoot.innerHTML = `
        <style>
          .container {
            position: relative;
          }
          .text {
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            line-height: 1.5;
            overflow: hidden;
          }
          .text.expanded {
            -webkit-line-clamp: unset;
          }
          .button {
            cursor: pointer;
            color: var(--text);
            border: none;
            background: none;
            padding: 0;
            font-size: 16px;
            text-decoration: underline;
            text-underline-offset: 4px;
            margin-top: 0.5em;
          }
        </style>
        <div class="container">
          <p class="text"><slot></slot></p>
          <button class="button">Read more</button>
        </div>
      `;
      this.textElement = this.shadowRoot.querySelector(".text");
      this.buttonElement = this.shadowRoot.querySelector(".button");
      this.buttonElement.addEventListener("click", () => this.toggleText());
    }
    toggleText() {
      const expanded = this.textElement.classList.toggle("expanded");
      this.buttonElement.textContent = expanded ? "Read less" : "Read more";
    }
  }

  if (!customElements.get('truncate-text')) {
    customElements.define("truncate-text", TruncateText);
  }

  // Rewrap Badge Functionality
  // Watch for .r-app-content-loaded to have content and add rewrap badges to .r-pdp-image elements
  function addRewrapBadges() {
    const appContentContainer = document.querySelector('.r-app-content-loaded');
    
    if (!appContentContainer) {
      return;
    }

    // Check if container has meaningful content (not just whitespace)
    const hasContent = appContentContainer.children.length > 0 || 
                      (appContentContainer.textContent && appContentContainer.textContent.trim().length > 0);
    
    if (hasContent) {
      const pdpDesktopImage = document.querySelector('.r-pdp-images-desktop .r-pdp-image');
      if (pdpDesktopImage) {
        addRewrapBadgesToPdpImages(pdpDesktopImage);
      }
      const pdpMobileImage = document.querySelector('.r-pdp-mobile-image .r-pdp-image');
      if (pdpMobileImage) {
        addRewrapBadgesToPdpImages(pdpMobileImage);
      }
    }
  }

  function addRewrapBadgesToPdpImages(imageElement) {
    // Check if badge already exists to avoid duplicates
    if (imageElement.querySelector('.rewrap-badge')) {
      return;
    }
    
    // Create rewrap badge element
    const rewrapBadge = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    rewrapBadge.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    rewrapBadge.setAttribute('viewBox', '0 0 752.58 96.44');
    rewrapBadge.setAttribute('class', 'rewrap-badge icon icon-rewrap');
    rewrapBadge.setAttribute('style', 'height: 13px;width: 100px;');
    rewrapBadge.innerHTML = `
        <polygon stroke-width="0" fill="#fff" points="477.77 89.32 464.12 34.47 463.89 34.47 450.46 89.32 432.52 89.32 411.19 8.74 428.91 8.74 441.66 63.59 441.89 63.59 455.88 8.74 472.47 8.74 486.24 64.27 486.46 64.27 499.67 8.74 517.05 8.74 495.38 89.32 477.77 89.32"/>
        <path stroke-width="0" fill="#010202" d="m498.56,7.34l-12.24,51.44-12.75-51.44h-18.78l-12.96,50.8-11.81-50.8h-20.66l22.07,83.39h20.12l11.86-48.42,12.73,48.1h.44l.08.32h19.78l22.43-83.39h-20.32Zm-49.17,80.46l-6.13-23.87,12.7-49.81,5.96,22.51-12.53,51.17Zm44.92.12h-.87l-5.95-22.24h.08l13.21-55.53h14.44l-20.92,77.77Z"/>
        <path stroke-width="0" fill="#010202" d="m41.62,8.17c5.2,0,10.04.83,14.52,2.49s8.36,4.16,11.64,7.48c3.28,3.33,5.84,7.48,7.69,12.47,1.84,4.99,2.77,10.84,2.77,17.57,0,5.89-.75,11.34-2.26,16.32s-3.79,9.29-6.84,12.93c-3.05,3.62-6.86,6.48-11.41,8.56-4.56,2.08-9.93,3.12-16.1,3.12H6.83V8.18h34.79Zm-1.24,65.97c2.56,0,5.05-.42,7.46-1.25,2.41-.83,4.56-2.21,6.44-4.14,1.88-1.93,3.39-4.44,4.52-7.54,1.13-3.09,1.69-6.87,1.69-11.33,0-4.08-.4-7.77-1.18-11.05-.79-3.29-2.09-6.1-3.9-8.45-1.81-2.34-4.2-4.14-7.17-5.39-2.98-1.25-6.65-1.87-11.02-1.87h-12.66v51.01h15.82Z"/>
        <polygon stroke-width="0" fill="#010202" points="132.52 8.17 114.32 65.07 114.1 65.07 96.13 8.17 77.94 8.17 104.04 89.1 124.04 89.1 150.82 8.17 132.52 8.17"/>
        <polygon stroke-width="0" fill="#010202" points="159.74 8.17 159.74 89.05 177.47 89.05 177.47 55.64 211.23 55.64 211.23 41.81 177.47 41.81 177.47 23.12 216.43 23.12 216.43 8.17 159.74 8.17"/>
        <path stroke-width="0" fill="#010202" d="m407.31,90.84h-63.98V7.46h63.07v17.7h-42.54v14.46h39.05v16.58h-39.05v16.94h43.45v17.71Zm-61.17-2.81h58.36v-12.09h-43.45v-22.56h39.05v-10.96h-39.05v-20.08h42.54v-12.08h-57.45v77.77Z"/>
        <path stroke-width="0" fill="#010202" d="m286.41,90.74h-20.53V7.36h44.85c3.78,0,7.24.62,10.29,1.85,3.05,1.23,5.71,2.95,7.91,5.1,2.2,2.16,3.9,4.69,5.06,7.52,1.16,2.83,1.74,5.92,1.74,9.16,0,4.96-1.07,9.33-3.18,13-1.69,2.94-4.25,5.35-7.63,7.18,1.12.54,2.12,1.19,2.99,1.95,1.56,1.35,2.84,2.96,3.82,4.8.97,1.83,1.67,3.83,2.11,5.97.42,2.05.72,4.16.87,6.26.08,1.3.15,2.81.23,4.55.07,1.68.2,3.44.38,5.22.17,1.66.46,3.32.86,4.93.36,1.43.91,2.66,1.63,3.65l1.62,2.23h-21.45l-.35-.9c-1.02-2.67-1.66-5.88-1.9-9.55-.21-3.44-.55-6.82-1-10.06-.56-3.88-1.72-6.73-3.44-8.45-1.67-1.67-4.56-2.52-8.6-2.52h-16.32v31.49Zm-17.72-2.81h14.91v-31.49h19.12c4.81,0,8.37,1.12,10.58,3.34,2.19,2.19,3.58,5.47,4.24,10.04.46,3.31.8,6.77,1.02,10.27.19,2.97.66,5.6,1.4,7.82h14.32c-.33-.74-.6-1.53-.81-2.38-.44-1.75-.76-3.54-.94-5.33-.19-1.83-.33-3.65-.4-5.38-.08-1.71-.15-3.21-.23-4.48-.15-1.97-.42-3.96-.82-5.89-.38-1.88-1-3.63-1.84-5.22-.81-1.53-1.88-2.87-3.18-4-1.26-1.09-2.9-1.92-4.87-2.47l-1.03-.28v-2.25l.88-.35c4.2-1.69,7.25-4.14,9.07-7.3,1.86-3.23,2.8-7.14,2.8-11.6,0-2.88-.52-5.6-1.54-8.1-1.01-2.48-2.5-4.69-4.42-6.58-1.93-1.89-4.28-3.41-6.99-4.5-2.71-1.09-5.82-1.65-9.23-1.65h-42.05v77.77Zm35.74-41.33h-20.81v-25.49h20.81c4.38,0,7.77,1.01,10.06,2.99,2.35,2.05,3.53,5.27,3.53,9.58-.01,4.46-1.19,7.77-3.52,9.85-2.28,2.03-5.67,3.07-10.07,3.07Zm-18.01-2.81h18.01c3.69,0,6.45-.79,8.21-2.35,1.7-1.52,2.57-4.13,2.58-7.76,0-3.46-.86-5.97-2.57-7.46-1.76-1.53-4.53-2.3-8.22-2.3h-18.01v19.87Z"/>
        <path stroke-width="0" fill="#010202" d="m591.97,85.2c-.41-1.62-.72-3.33-.9-5.13-.19-1.81-.32-3.57-.39-5.3-.08-1.73-.15-3.23-.23-4.51-.15-2.03-.43-4.06-.85-6.09-.41-2.03-1.07-3.89-1.97-5.59-.9-1.69-2.07-3.16-3.5-4.4s-3.24-2.16-5.42-2.76v-.23c4.51-1.81,7.77-4.44,9.76-7.9s2.99-7.56,2.99-12.3c0-3.08-.55-5.96-1.64-8.63-1.09-2.67-2.67-5.02-4.74-7.05s-4.55-3.63-7.45-4.8-6.15-1.75-9.76-1.75h-43.45v80.58h17.72v-31.49h17.72c4.44,0,7.64.98,9.59,2.93,1.96,1.96,3.23,5.04,3.84,9.25.45,3.24.79,6.62,1.01,10.16.23,3.54.83,6.58,1.81,9.14h17.72c-.83-1.14-1.45-2.51-1.86-4.13m-21.27-42.71c-2.03,1.81-5.08,2.71-9.14,2.71h-19.41v-22.68h19.41c4.06,0,7.11.89,9.14,2.65,2.03,1.77,3.05,4.61,3.05,8.52,0,4.06-1.02,6.99-3.05,8.8"/>
        <path stroke-width="0" fill="#010202" d="m649.3,8.74h-18.17l-30.47,80.58h17.83l6.32-17.94h30.13l6.09,17.94h18.4l-30.13-80.58Zm-19.87,49.43l10.5-29.57h.23l10.16,29.57h-20.89Z"/>
        <path stroke-width="0" fill="#010202" d="m719.39,60.01h-17.16v29.06h-16.78V8.26h35.2c8.11,0,14.58,2.08,19.41,6.25,4.82,4.17,7.24,10.62,7.24,19.35,0,9.54-2.41,16.28-7.24,20.23-4.83,3.95-11.72,5.92-20.67,5.92Zm7.89-16.83c2.19-1.94,3.29-5.01,3.29-9.21s-1.11-7.2-3.32-8.99c-2.21-1.79-5.31-2.69-9.29-2.69h-15.73v23.79h15.73c3.99,0,7.09-.96,9.32-2.9Z"/>
    `;
    
    // Position the badge relative to the image container
    imageElement.style.position = 'relative';
    imageElement.appendChild(rewrapBadge);
  }

  // Initialize the observer
  function initRewrapBadgeObserver() {
    const appContentContainer = document.querySelector('.r-app-content-loaded');
    
    if (appContentContainer) {
      // Create a MutationObserver to watch for content changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            addRewrapBadges();
          }
        });
      });
      
      // Start observing
      observer.observe(appContentContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
      
      // Also check immediately in case content is already loaded
      setTimeout(() => {
        addRewrapBadges();
      }, 100);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRewrapBadgeObserver);
  } else {
    initRewrapBadgeObserver();
  }

  // Also initialize after a delay to catch any late-loading content
  setTimeout(initRewrapBadgeObserver, 1000);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

(function() {
  /*
    Data Layer Push for Country Variable
    Pushes the country value from window.Shopify.country to the data layer
  */

  document.addEventListener('DOMContentLoaded', function() {
    window.dataLayer = window.dataLayer || [];

    var country = window.Shopify && window.Shopify.country ? window.Shopify.country : null;
    if (country) {
      window.dataLayer.push({
        'event': 'DL - WKND Tag',
        'country': country
      })
    } else {
      console.warn('Shopify country not found');
    }
  });
})();
